import { apiClient } from './apiClient';

const fetchViewers = async (payload) => {
  return await apiClient.get('/dashboard/viewers', payload);
};

export const viewerApi = {
  fetchViewers
};
